import vm from "../main";

export const $on = (event, callback) => {
  vm.$on(event, callback)
}

export const $emit = (event, args) => {
  vm.$emit(event, args)
}

export const $once = (event, args) => {
  vm.$once(event, args)
}

export const $off = (event, callback) => {
  vm.$off(event, callback)
}

export const eventList = {
  getHomePageHint: 'getHomePageHint',
  updateUnReadNum: 'updateUnReadNum'
}



// WEBPACK FOOTER //
// ./src/utils/vueBus.js